

'use strict';

angular.module('pulianiBookStoreApp')
  .config(function ($stateProvider) {
    $stateProvider
      .state('privacyPolicy', {
        url: '/privacyPolicy',
        templateUrl: 'app/privacy_policy/privacy_policy.html',
        controller: 'PrivacyPolicyCtrl'
      });
  });
